/**
 * 具有权限的按钮
 */
import React from 'react';
import {Input} from 'antd';
import './index.scss'
import {WWMethods} from "@/tools";
export default class WWInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {

    }
    render() {
        // 将此组件的参数过滤
        const {type, className,onChange, ...otherProps} = this.props;
        return (
            <Input type={type} maxLength={64} style={{height:30}} className={className}  onChange={(e)=>{
                let value = WWMethods.trimStr(e.target.value);
                onChange(value);
            }} {...otherProps}/>
        )
    }
}
